import { nanoid } from '@reduxjs/toolkit';

import { designService } from '@paragon/data-connections';

import { metricsFailed, metricsLoaded, metricsRequested } from '../slices/projectMetricsSlice';
import { AsyncThunkActionVoid } from './thunkActions';

export function ensureProjectMetrics(projectGuid: string, retry = false): AsyncThunkActionVoid {
  return async (dispatch, getState) => {
    const state = getState();
    if (!state.layoutModels[projectGuid]) return;

    const entry = state.projectMetrics[projectGuid];
    if (entry && entry.status !== 'idle' && !(retry && entry.status === 'error')) return;

    const request = { projectGuid, requestId: nanoid() };
    dispatch(metricsRequested(request));

    try {
      const data = await designService.projects.fetchMetrics(projectGuid);
      dispatch(metricsLoaded({ ...request, data }));
    } catch (error) {
      console.error(error);
      dispatch(metricsFailed(request));
    }
  };
}
